import { TSummaryResponse } from "domain/entities/generic-type";
import { TPageSummary } from "../entities/page-summary-response";

export class PageSummaryModel {
  static from(pageSummaryresponse: TSummaryResponse): TPageSummary {
    return {
      cards: pageSummaryresponse.cards,
      range: pageSummaryresponse.range,
      summary: {
        dataColumns: [
          {
            header: "Page",
            accessor: "name"
          },
          {
            header: "Unique visitors",
            accessor: "visitors"
          },
          {
            header: "Converted",
            accessor: "converted"
          },
          {
            header: "Drop-offs",
            accessor: "exits"
          },
          {
            header: "Avg. Time",
            accessor: "averageTime",
            tooltipMessage: "The average time only consider users that have done at least one action on the page."
          },
          {
            header: "Medium",
            accessor: "utm",
            tooltipMessage: "The medium from where the traffic is coming."
          },
        ],
        dataRows: pageSummaryresponse.table.map(
          (pageSummary) => {
            return {
              name : pageSummary.name,
              visitors: `${pageSummary.visitors} (${pageSummary.visitorsPercentage}%)`,
              converted: `${pageSummary.converted} (${pageSummary.convertedPercentage}%)`,
              exits: `${pageSummary.bounced} (${pageSummary.bouncedPercentage}%)`,
              averageTime: pageSummary.averageTime,
              utm: pageSummary.utm,
            };
          }
        ),
      }
    }
  }
}
